import React from "react"

interface Props {
  children: React.ReactNode,
  name: string,
  equalPadding?: boolean
}

const Tab = (props: Props) => {
  return (
    <div
      className={props.equalPadding ? "tabs__content equal-padding" : "tabs__content"}
    >
      {props.children}
    </div>
  )
}

export default Tab
